import messages from "components/messagesDescription";
import { isEmpty } from "cxa-utils";

/**
 * -----------------------------------------------------------
 * Benefits error handler
 * @see {@link https://cxagroup.atlassian.net/browse/APL-4476}
 * -----------------------------------------------------------
 * - new
 * benefitError101
 * benefitError105
 * benefitError111
 * benefitError113
 * benefitError114
 * benefitError115
 * benefitError116
 *
 * - exist
 * benefitError102
 * benefitError103
 * benefitError104
 * benefitError106
 * benefitError107
 * benefitError108
 * benefitError109
 * benefitError110
 * benefitError112
 */

/**
 * Locale Map
 * @type {Object}
 */
const LOCALE_MAP = {
  benefits_101: messages.benefitError101,
  benefits_102: messages.benefitError102,
  benefits_103: messages.benefitError103,
  benefits_104: messages.benefitError104,
  benefits_105: messages.benefitError105,
  benefits_106: messages.benefitError106,
  benefits_107: messages.benefitError107,
  benefits_108: messages.benefitError108,
  benefits_109: messages.benefitError109,
  benefits_110: messages.benefitError110,
  benefits_111: messages.benefitError111,
  benefits_112: messages.benefitError112,
  benefits_113: messages.benefitError113,
  benefits_114: messages.benefitError114,
  benefits_115: messages.benefitError115,
  benefits_116: messages.benefitError116,
};

function getExtraValues(v) {
  const extraArr = Array.isArray(v) ? v : [v]; // create stream
  const len = extraArr.length;

  return extraArr.reduce((acc, extraValue, idx) => {
    if (isEmpty(extraValue)) {
      return acc;
    }

    const key = len > 1 ? `extraValue-${idx + 1}` : "extraValue";

    return {
      ...acc,
      [key]: extraValue,
    };
  }, "");
}

export default function benefitsErrorHandler(intl, localeMap = LOCALE_MAP) {
  return ({ messageKey, message, extraValue }) => {
    if (isEmpty(messageKey || message)) {
      return null;
    }

    const localeObj = localeMap[messageKey];
    const extraValues = getExtraValues(extraValue);
    const locale = localeObj || {
      id: message,
      defaultMessage: message,
    };
    const args = [locale, extraValues];

    return intl.formatMessage(...args);
  };
}



// WEBPACK FOOTER //
// ./utils/benefitsErrorHandler.js